//import * as all from './fce_all.js';

//import { Top } from "../class/Top.js";
import { Top } from "../class/Top.js";
import { ZahPrazdnyKosik } from "../class/ZahPrazdnyKosik.js";
import { Translation as Tr } from "../class/Translation.js";

function zah_vratVlajecku() {
  Lc.f("zah_vratVlajecku", Top);

  let Jz = {
    cs: "CZ",
    en: "GB",
    pl: "PL",
    hu: "HU",
  };

  return `<span style="
  line-height: 40px;
  vertical-align: middle;
  padding: 0;
  margin: 0;
  display: inline-block;
  position: relative;
  top: 5px;
"><svg class="shp-flag shp-flag-${Jz[Top.jazyk]}">
              <use xlink:href="#shp-flag-${Jz[Top.jazyk]}"></use>
               </svg></span>`;
}

function zah_upravaPolozekNavigace() {
  $(".navigation-in.menu > ul >li").each(function(index) {
    if (index > 6) $(this).remove();
  });
  $(".menu-helper").html("<span>" + shoptet.messages["more"] + "</span></div>");
  $(".navigation-in > ul")
    .clone()
    .appendTo(".menu-helper");

  //shoptet.splitMenu();
  shoptet.menu.splitMenu();
  /* updateMenu();
      toggleMenu();*/

  $(".navigation-in > ul").each(function() {
    if (!$("body").hasClass("type-index")) {
      $(this).prepend(zah_menu_li(Tr.l("_domu"), "/"));
    }

    //var $valMenu = window.odkazy.zahlavi;
    var $valMenu = Tr.obj("zahlavi_odkazy_neon");
    Lc.h(" $valMenu", $valMenu);
    for (var $k in $valMenu) {
      var $val = $valMenu[$k];

      $(this).append(zah_menu_li($k, $val));
    } //for
  });
} //function  zah_upravaPolozekNavigace()

function zah_menu_li($text, $odkaz) {
  var $styl = 'class="hidden"';

  return (
    "<li " + $styl + '><a href="' + $odkaz + '"><b>' + $text + "</b></a></li>"
  );
} //function zah_menu_li

function zah_nactiKosik() {
  Lc.f("zah_nactiKosik");

  var $a = $("a.cart-count .cart-price").clone();
  Lc.log("text kosiku", $a.text().trim());
  let stav = window.getShoptetDataLayer("cart");
  Lc.log("stav", stav.length);
  /*
  if ($a.text().trim() == shoptet.messages["emptyCart"]) {
    $a = "<span>" + shoptet.messages["emptyCart"] + "</span>";
  }
  
  */
  $("#dvTop #dvKos .celkem,#dvTop .respons .kosik .celkem").each(function() {
    let t = $(this);
    if (t.is(":visible") && !stav.length) {
      t.hide();
    }
    if (t.is(":hidden") && stav.length) {
      t.show();
    }
  });

  if (!stav.length) {
    //$a = fce.prevedFormatujDleMeny(0);
  }
  $("#dvTop #dvKos strong,#dvTop .respons .kosik strong").html($a);
} //function zah_nactiKosik()

function zah_odkazy_lista() {
  var $odkazy = "";

  //var $valMenu = window.odkazy.zahlavi;
  var $valMenu = Tr.obj("zahlavi_odkazy_neon");
  for (var $k in $valMenu) {
    var $val = $valMenu[$k];

    $odkazy += '<a href="' + $val + '">' + $k + "</a> ";
  } //for

  return $odkazy;
} //function  zah_odkazy_lista()

function zah_lista() {
  var $kod = `
  <div class="leva">
    <div class="links">
      <a class="tel" href="mailto:${window.kontakty.tel_odkaz}">
        ${window.kontakty.tel}
      </a>
      <a class="email" href="mailto:${window.kontakty.email}">
        ${window.kontakty.email}
      </a>
    </div>
  </div>`;

  $kod +=
    '<div class="prava"> \
        <div class="links"> \
               ' +
    zah_odkazy_lista() +
    " \
         </div> \
   </div>";

  $kod += '<div id="dvHledat"></div>';

  return $kod;
} //function  zah_lista()

function zah_prihlaseni() {
  var $kod = '<div class="login"><span><em>';
  //$prihlasen=true;

  if (Top.Uzivatel.prihlasen) {
    $kod += `<a href="${Tr.l("url_muj_ucet")}">${Tr.l(
      "_muj_ucet",
    )}</a> / <a href="${Tr.l("url_logout")}">${Tr.l("_odhlasit_se")}</a>`;
  } else {
    $kod += `<a href="${Tr.l("url_login")}">${Tr.l(
      "_prihlaseni",
    )}</a> / <a href="${window.shoptet.config.registerUrl}">${Tr.l(
      "_registrace",
    )}</a>`;
  }

  $kod += '</em></span></div><!-- class="login"-->';

  return $kod;
} //function  zah_prihlaseni()

function zah_login_odkaz() {
  if (Top.Uzivatel.prihlasen) return "/klient/";

  return "#";
} //function  zah_login_odkaz()

function zah_upravHeader() {
  Lc.f("zah_upravHeader");

  var div = $('<div id="dvTop" class="cntmax"></div>');
  div.prependTo("header#header");

  var kod = `
  <div class="respons">
              <div class="a">
                <div class="dvMena"></div>
                <a href="#" class="hledej toggle-window" data-target="search"></a>
                <a href="${zah_login_odkaz()}" class="user toggle-window" data-target="login"></a>
              </div><!-- class="a"-->
              <div class="c">
                    <a class="kosik" href="${Tr.l("url_kosik")}">
                      <strong>KOŠÍK</strong> </a>
                    <a href="#" class="respMenu toggle-window" data-target="navigation"></a>
              </div><!-- class="a"-->
  </div><!-- class="respons"-->
  
  
  <div class="flx">
  <div class="leva">
    <div class="a">
      <div class="logo"></div>
    </div>
  </div>
  <div class="prava">
    <nav id="navSec" class="secondary-navigation" aria-label="Sekundární navigace">
      <ul id="ulNav2">
      </ul>
    </nav>
  </div><!-- class="prava"-->
  </div>`;

  div.append(kod);

  //presun loga
  $(".site-name a").appendTo("#dvTop .leva .a .logo");
  $("#navigation").appendTo("#dvTop .leva");
  $(".menu-helper").appendTo("#dvTop .leva");

  let ul2 = $("#navSec > ul");
  let liKonfigurace = $("#navigation .navigation-in > ul.menu-level-1 > li").eq(
    2,
  );

  Lc.h("liKonfigurace", liKonfigurace);
  Lc.log("jazyk", Top.jazyk);

  if (Top.jazyk == "cs") {
    liKonfigurace.appendTo(ul2);
  }

  $("#navigation .navigation-in > ul.menu-level-1 > li")
    .slice(Top.jazyk == "cs" ? 2 : 3)
    .clone()
    .appendTo(ul2);

  //jazykovy prepinac

  $(
    '.top-navigation-tools .languagesMenu .languagesMenu__box[data-target="language"]',
  ).each(function() {
    Lc.h("#topNavigationDropdown");
    var $this = $(this);

    let d = $this.find(".languagesMenu__header--actual");
    let vl = zah_vratVlajecku();
    d.prepend(vl);

    //var n = $this.closest(".dropdown").clone();
    let n = $this.clone();
    n.appendTo(".respons .a");

    ul2.append('<li class="liJazyk"></li>');

    $this.appendTo("#ulNav2 .liJazyk");
    //var m = $this.closest(".dropdown").clone();

    //m.appendTo(".respons .a .dvMena");
  });

  //hledani
  ul2.append('<li class="liHledani"></li>');

  $(".header-top  .search").appendTo(".liHledani");

  $(".liHledani").append(
    `<a href="#" class="hledej toggle-window" data-target="search"></a>`,
  );

  //prihlasovani
  ul2.append(`<li class="liPrihl">
<button
  class="top-nav-button top-nav-button-login toggle-window"
  type="button"
  data-target="login"
  aria-haspopup="dialog"
  aria-controls="login"
  aria-expanded="false"
  data-testid="signin"
>
  <span>Přihlášení</span>
</button></li>`);

  //kosik
  ul2.append('<li class="liKosik"></li>');

  $(".header-top .cart-count").appendTo(".liKosik");

  Lc.log("resize");
  window.shoptet.menu.updateMenu();

  $(window).on("resize", function() {
    Lc.log("resize");
    window.shoptet.menu.updateMenu();
  });
}

/*
function zah_prazdnyKosikHoverOkno() {
  var $cartTrigger = $('.toggle-window[data-target="cart"]');

  if (!$cartTrigger.length) {
    return;
  }

  if (!$("#empty-cart-hover-window").length) {
    $("body").append(`
            <div id="empty-cart-hover-window" class="empty-cart-hover-window">
                Košík je zatím prázdný.
            </div>
        `);
  }

  var $emptyWindow = $("#empty-cart-hover-window");
  var hideTimer = null;

  function showWindow() {
    clearTimeout(hideTimer);

    // Otevřít jen když je košík prázdný
    if (!$cartTrigger.hasClass("full")) {
      $emptyWindow.addClass("visible");
    }
  }

  function hideWindow() {
    hideTimer = setTimeout(function() {
      $emptyWindow.removeClass("visible");
    }, 200);
  }

  $cartTrigger
    .off("mouseenter.emptyCartHover mouseleave.emptyCartHover")
    .on("mouseenter.emptyCartHover", showWindow)
    .on("mouseleave.emptyCartHover", hideWindow);

  $emptyWindow
    .off("mouseenter.emptyCartHover mouseleave.emptyCartHover")
    .on("mouseenter.emptyCartHover", function() {
      clearTimeout(hideTimer);
    })
    .on("mouseleave.emptyCartHover", hideWindow);
}
*/

function mm(c) {
  var s = c || 0;
  console.log("zobrazeni navigace nastaveno");
  $("body").addClass("submenu-visible");
  $("nav#navigation .navigation-in > ul > li:eq(" + s + ")").addClass("exp");
} //function  mm()

export function upravZahlavi() {
  //https://www.5mfencing.com/sportovni-serm/?mm&menu
  Lc.f("upravZahlavi");

  zah_upravHeader();

  zah_nactiKosik();

  document.addEventListener("ShoptetCartUpdated", function() {
    zah_nactiKosik();
  });

  window.pp = function() {
    zobraz_kosik();
  };
  window.mm = mm;

  /*
  let skryvatPodmenu = true;
  if (Top.UrlSite.searchParams.has("menu")) {
    skryvatPodmenu = false;
  }
  */

  let zakazSkryvatPodmenu = Top.UrlSite.searchParams.has("menu");

  if (zakazSkryvatPodmenu && Top.localhost) {
    Lc.f("shoptet.menu.hideSubmenu");
    shoptet.menu.hideSubmenu = function() {
      Lc.log("moje hideSubmenu");
      // vlastní kód
    };
  }

  let spustitMm = Top.UrlSite.searchParams.has("mm");

  if (spustitMm && Top.localhost) {
    mm(0);
  }

  //zah_prazdnyKosikHoverOkno();

  /*
  $("a.hledej").on("click", function(e) {
    Lc.log("klik hledani");
    e.preventDefault();
    if ($("body").hasClass("search-window-visible")) {
      Lc.log("hledani uz je otevrene, nic nedelam");
      $("body").removeClass("search-window-visible");
    }
  });
  */

  //zruseni zobrazeni vyhledvaciho pole

  $(document).on("click", function(e) {
    if (!$("body").hasClass("search-window-visible")) return;

    if (
      $(e.target).closest(
        "a.hledej,.search, .search-form, .searchWhisperer, .search-whisperer, .js-try-search-button, .search-input-icon",
      ).length
    ) {
      return;
    }

    $("body").removeClass(
      "user-action-visible search-window-visible search-focused",
    );
  });

  ZahPrazdnyKosik._init();
}

export function upravZahlavi_old() {
  /*
  if (Top.novaSablona) {
    return zah_upravZahlaviNovyDesign();
  }
  */

  Lc.f("upravZahlavi");
  zah_upravaPolozekNavigace();

  var $kod = "";
  $kod += '<div id="dvTop"><div class="cntmax">';

  //----responsize
  $kod += `<div class="respons">
              <div class="a">
                <div class="dvMena"></div>
                <a href="#" class="hledej toggle-window" data-target="search"></a>
                <a href="${zah_login_odkaz()}" class="user toggle-window" data-target="login"></a>
              </div><!-- class="a"-->
              <div class="b">${zah_odkazy_lista()}</div><!-- class="a"-->
              <div class="c">
                    <a class="kosik" href="${Tr.l("url_kosik")}">
                      <strong>KOŠÍK</strong> </a>
                    <a href="#" class="respMenu toggle-window" data-target="navigation"></a>
              </div><!-- class="a"-->
          </div><!-- class="respons"-->`;

  $kod +=
    '<div id="dvLogo"><a href="/" class="logo"><img src="' +
    $shoptetUpload +
    '/5m_logo_v1.png" alt="" height="44" width="82"></a></div>';

  var $fce = zah_lista();
  if ($fce.length) {
    $kod += `<div class="dvp1"> \
              <div class="dvZL"><div class="cnt">
              ${$fce}
              </div></div><!--class="dvZL" -->  \
              <div class="dvA"><div class="cnt">  \
              <div id="dvM"></div>  \
              <div class="dvMena"></div>
              ${zah_prihlaseni()}
              <div id="dvKos"><a href="${Tr.l(
                "url_kosik",
              )}"><span class="celkem">
              ${Tr.l("_stav_kosiku")}
              </span> \
                        <strong class="dvTxtKos">KOŠÍK</strong>  \
                      </a></div><!--dvKos--> \
                      </div></div><!--class="dvA" -->  \
              </div>
              `;
  }

  $kod += '</div></div><!--id="dvTop" -->';

  $($kod).insertBefore(".top-navigation-bar");

  $("#navigation").appendTo("#dvM");

  $(".header-top .search").appendTo("#dvHledat");
  $("#dvHledat").each(function() {
    $(this)
      .find("button.btn")
      .text("");
  });

  //$('.top-navigation-tools .languagesMenu .languagesMenu__box[data-target="language"]').appendTo('.dvp1 .dvA .cnt');
  //jazykovy prepinac

  $(
    '.top-navigation-tools .languagesMenu .languagesMenu__box[data-target="language"]',
  ).each(function() {
    Lc.h("#topNavigationDropdown");
    var $this = $(this);

    let d = $this.find(".languagesMenu__header--actual");
    let vl = zah_vratVlajecku();
    d.prepend(vl);

    //var n = $this.closest(".dropdown").clone();
    let n = $this.clone();
    n.appendTo(".respons .a");

    $this.appendTo(".dvp1 .dvA .cnt");
    //var m = $this.closest(".dropdown").clone();

    //m.appendTo(".respons .a .dvMena");
  });

  zah_nactiKosik();

  $(".languagesMenu__list as").click(function(e) {
    Lc.log("zmena jazyka");
    let a = $(this);
    window.location.href = "/" + a.attr("href").slice(-2) + "/";
    //https://602246.myshoptet.com/action/Language/changeLanguage/?language=cs
    //window.location.href = "https://602246.myshoptet.com/cs/";
    //window.location.href = "https://602246.myshoptet.com/" + a.attr("href");
    ///action/Language/changeLanguage/?language=cs
    e.preventDefault();
  });
  //----po auktualizaci kosiku
  document.addEventListener("ShoptetCartUpdated", function() {
    zah_nactiKosik();
  });
} //export function  upravZahlavi()

export function odstranListuPrepocetCen() {
  if ($("body").hasClass("bdIframe")) {
    $("#topNavigationDropdown")
      .closest(".dropdown")
      .hide();
  }
}

function zobraz_kosik() {
  $("body").addClass("user-action-visible cart-window-visible");
}

//----nový design šablony
/*
function zah_upravZahlaviNovyDesign() {
  Lc.f("zah_upravZahlaviNovyDesign");
}
*/
